import React from 'react';
import { Container, Title, Subtitle } from './styles.js';
import { Box } from '../Box/Box.js';
import Link from '../Link/Link.js';

const SplashFeedback = ({ image, subtitle, link, title, }) => (React.createElement(Container, { "data-testid": "splash-feedback" },
    image && (React.createElement(Box, { mb: "34px" },
        React.createElement("img", { src: image, alt: title }))),
    React.createElement(Title, null, title),
    React.createElement(Subtitle, null, subtitle),
    link && React.createElement(Link, { href: link.href }, link.text || '')));

export { SplashFeedback as default };
